import { Component } from '@angular/core';
import { Consent } from '@models/models';
import { Location } from '@angular/common';
import { ConsentListComponent } from '@components/base/client/consent-list/consent-list';
import { ConsentMethods } from '@components/base/client/consent-list/consent-list.model';

@Component({
	selector: 'consent-list',
	template: require('./consent-list.html')
})
export class ConsentListWebComponent extends ConsentListComponent {
	public consentMethods = ConsentMethods;

	constructor(private location: Location) {
		super();
	}

	public goToSource(consent: Consent, event): void {
		if (event.path[1].className.includes('btn')) {
		} else {
			const { contractId, jobId, questionnaireId, isLead, leadId } = consent;
			switch (consent.method) {
				case ConsentMethods.BY_CONTRACT:
					if (contractId && jobId && !isLead) {
						this.location.go(`/jobs/view/${jobId}/contracts/${contractId}`);
					} else if (contractId && jobId && isLead) {
						this.location.go(`/leads/view/${leadId}/contracts/${contractId}`);
					}
					break;
				case ConsentMethods.BY_QUESTIONNAIRE:
					if (questionnaireId && jobId && !isLead) {
						this.location.go(
							`/jobs/view/${jobId}/questionnaires/${questionnaireId}`
						);
					} else if (questionnaireId && jobId && isLead) {
						this.location.go(
							`/leads/view/${leadId}/questionnaires/${questionnaireId}`
						);
					}
					break;
				default:
			}
		}
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=nfw9yna8xro!./web/modern/components/client/consent-list/consent-list.ts